import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  TextField,
  ThemeProvider,
} from "@material-ui/core";
import { SelectTheme } from "../../../../../utils/utils";
import DeleteIcon from "@material-ui/icons/Delete";
import { LanguagesWithLanguageCode } from "../../../../../utils/constants";
import Form from "react-bootstrap/Form";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import LanguageDropdown from "../../../../Common/Dropdowns/LanguageDropdown";
import { Uuidv4 } from "../../../../../services/helpers";
import appFetch from "../../../../../api/appFetch";
import DeleteConfirmationModal from "../../../../Common/Modals/DeleteConfirmationModal";

const SignableDocumentsDescriptionSection = ({
  resources,
  description,
  handleDescriptionChange,
  descriptionTranslations,
  setDescriptionTranslations,
  documentId,
  hasError
}) => {
  const [shouldShowAddTranslationField, setShouldShowAddTranslationField] =
    useState(false);
  const [translationContent, setTranslationContent] = useState("");
  const [selectedTranslationLanguage, setSelectedTranslationLanguage] =
    useState(null);
  useEffect(() => {
    if (descriptionTranslations.length === LanguagesWithLanguageCode.length) {
      setShouldShowAddTranslationField(false);
    }
  }, [descriptionTranslations]);

  async function removeLanguage(textLanguage) {
    setDescriptionTranslations((prev) =>
      prev.filter((text) => text.language !== textLanguage)
    );
  }

  function getFirstUnusedLanguage(filteredDescriptionTranslations) {
    const unused = LanguagesWithLanguageCode.filter(
      (l) =>
        !filteredDescriptionTranslations.find(
          (text) => text.language === l.code
        )
    );

    if (unused && unused.length > 0) {
      return unused[0].code;
    }

    return "";
  }

  function saveLanguage() {
    if (selectedTranslationLanguage && translationContent) {
      const descriptionTranslationsList = [
        ...descriptionTranslations,
        {
          id: Uuidv4(),
          language: selectedTranslationLanguage,
          description: translationContent,
        },
      ];

      setDescriptionTranslations(descriptionTranslationsList);

      setTranslationContent("");
      setSelectedTranslationLanguage(
        getFirstUnusedLanguage(descriptionTranslationsList)
      );
    }
  }

  function closeAddLanguage() {
    setTranslationContent("");
    setShouldShowAddTranslationField(false);
  }

  return (
    <>
      <ThemeProvider theme={SelectTheme}>
        <TextField
          style={{ width: "100%" }}
          id="signable-documents-description"
          value={description}
          label={resources["Description"]}
          helperText={resources["InputOfDescriptionIsMandatory"]}
          variant="outlined"
          name="description"
          onChange={handleDescriptionChange}
          inputProps={{ maxLength: 256 }}
          required
          className={hasError ? "helper-text-red" : "helper-text-grey"}
        />
      </ThemeProvider>

      <div style={{ marginBottom: "30px", marginTop: "5px" }}>
        {descriptionTranslations.map((text) => (
          <div key={text.id} className="d-flex">
            <div style={{ flex: 1 }} className="d-flex text-left px-0">
              <div style={{ width: "150px" }} className="px-0">
                {LanguagesWithLanguageCode.find((l) => l.code === text.language)
                  ?.Name ?? ""}
              </div>
              <div style={{ flex: 1 }} className="px-0">
                {text.description}
              </div>
              <div>
                <IconButton
                  id="delete-language"
                  onClick={() => {
                    removeLanguage(text.language);
                  }}
                  size="small"
                >
                  <DeleteIcon style={{ color: "#C4455B" }} />
                </IconButton>
              </div>
            </div>
          </div>
        ))}

        {!shouldShowAddTranslationField &&
          descriptionTranslations.length !==
            LanguagesWithLanguageCode.length && (
            <div
              style={{
                justifyContent: "flex-end",
                marginBottom: "5px",
                marginTop: descriptionTranslations.length > 0 ? "5px" : "0px",
              }}
              className="d-flex"
            >
              <div className="px-0 mb-3 text-right">
                <Button
                  id="add-language"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setSelectedTranslationLanguage(
                      getFirstUnusedLanguage(descriptionTranslations)
                    );
                    setShouldShowAddTranslationField(true);
                  }}
                >
                  <i
                    className="fas fa-plus mr-2"
                    title={resources["AddLanguage"]}
                  />
                  {resources["AddLanguage"]}
                </Button>
              </div>
            </div>
          )}

        {shouldShowAddTranslationField && (
          <div>
            <Form.Group className="pt-3 d-flex">
              <ThemeProvider theme={SelectTheme}>
                <LanguageDropdown
                  id="signable-documents-language-dropdown"
                  resources={resources}
                  language={selectedTranslationLanguage}
                  onLanguageChange={(e) => {
                    if (e.target && e.target.value)
                      setSelectedTranslationLanguage(e.target.value);
                  }}
                  containerClass="col-3 pr-2 helper-text-red"
                  filter={(l) =>
                    !descriptionTranslations.find(
                      (tt) => tt.language === l.code
                    )
                  }
                />

                <TextField
                  style={{ flex: 1 }}
                  id="signable-documents-language-description"
                  value={translationContent}
                  label={resources["Description"]}
                  variant="outlined"
                  name="languageDescription"
                  onChange={(e) => {
                    setTranslationContent(e.target.value);
                  }}
                  inputProps={{ maxLength: 256 }}
                />
                <div style={{ paddingLeft: "8px" }} className="text-left">
                  <IconButton id="signable-documents-confirm-add-language" onClick={() => saveLanguage()} size="small">
                    <CheckIcon  />
                  </IconButton>
                  <IconButton id="signable-documents-cancel-add-language" onClick={() => closeAddLanguage()} size="small">
                    <CloseIcon  />
                  </IconButton>
                </div>
              </ThemeProvider>
            </Form.Group>
          </div>
        )}
      </div>
    </>
  );
};

export default SignableDocumentsDescriptionSection;
